// 📄 components/layout/AppShell.tsx
// Envoltorio con el mismo fondo oscuro + navbar que usa OperativeApp,
// para las rutas que viven fuera del switch de páginas basado en estado
// (Registrar Cliente, Mis Proyectos, Nuevo Proyecto) y que de otra forma
// se renderizan "desnudas" sin la navegación principal.
import React from 'react';
import Navbar from './Navbar.tsx';

interface AppShellProps {
  children: React.ReactNode;
  activePage?: 'home' | 'clientes' | 'proyectos' | 'mensajes' | 'soporte' | 'ayuda';
}

export default function AppShell({ children, activePage }: AppShellProps) {
  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <Navbar activePage={activePage} />
      {children}
    </div>
  );
}
